// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type VercelTeamsForSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type VercelTeamsForSiteQuery = (
  { __typename?: 'Query' }
  & { nowTeamsForGatsbySiteId?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'NowTeam' }
    & Pick<Types.NowTeam, 'id' | 'name' | 'slug'>
  )>>> }
);

export type VercelProjectsForSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  teamId?: Types.Maybe<Types.Scalars['String']>;
}>;


export type VercelProjectsForSiteQuery = (
  { __typename?: 'Query' }
  & { nowProjectsForGatsbySiteId?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'NowProject' }
    & Pick<Types.NowProject, 'id' | 'name'>
  )>>> }
);


export const VercelTeamsForSiteDocument = gql`
    query VercelTeamsForSite($siteId: UUID!) {
  nowTeamsForGatsbySiteId(siteId: $siteId) {
    id
    name
    slug
  }
}
    `;

/**
 * __useVercelTeamsForSiteQuery__
 *
 * To run a query within a React component, call `useVercelTeamsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useVercelTeamsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVercelTeamsForSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useVercelTeamsForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VercelTeamsForSiteQuery, VercelTeamsForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<VercelTeamsForSiteQuery, VercelTeamsForSiteQueryVariables>(VercelTeamsForSiteDocument, baseOptions);
      }
export function useVercelTeamsForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VercelTeamsForSiteQuery, VercelTeamsForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VercelTeamsForSiteQuery, VercelTeamsForSiteQueryVariables>(VercelTeamsForSiteDocument, baseOptions);
        }
export type VercelTeamsForSiteQueryHookResult = ReturnType<typeof useVercelTeamsForSiteQuery>;
export type VercelTeamsForSiteLazyQueryHookResult = ReturnType<typeof useVercelTeamsForSiteLazyQuery>;
export type VercelTeamsForSiteQueryResult = ApolloReactCommon.QueryResult<VercelTeamsForSiteQuery, VercelTeamsForSiteQueryVariables>;
export const VercelProjectsForSiteDocument = gql`
    query VercelProjectsForSite($siteId: UUID!, $teamId: String) {
  nowProjectsForGatsbySiteId(siteId: $siteId, teamId: $teamId) {
    id
    name
  }
}
    `;

/**
 * __useVercelProjectsForSiteQuery__
 *
 * To run a query within a React component, call `useVercelProjectsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useVercelProjectsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVercelProjectsForSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useVercelProjectsForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VercelProjectsForSiteQuery, VercelProjectsForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<VercelProjectsForSiteQuery, VercelProjectsForSiteQueryVariables>(VercelProjectsForSiteDocument, baseOptions);
      }
export function useVercelProjectsForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VercelProjectsForSiteQuery, VercelProjectsForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<VercelProjectsForSiteQuery, VercelProjectsForSiteQueryVariables>(VercelProjectsForSiteDocument, baseOptions);
        }
export type VercelProjectsForSiteQueryHookResult = ReturnType<typeof useVercelProjectsForSiteQuery>;
export type VercelProjectsForSiteLazyQueryHookResult = ReturnType<typeof useVercelProjectsForSiteLazyQuery>;
export type VercelProjectsForSiteQueryResult = ApolloReactCommon.QueryResult<VercelProjectsForSiteQuery, VercelProjectsForSiteQueryVariables>;
